interface SummaryCardProps {
  label: string;
  value: string;
  detail?: string;
  trend?: { value: number; label: string };
}

export function SummaryCard({ label, value, detail, trend }: SummaryCardProps) {
  return (
    <div className="card p-4">
      <p className="text-sm" style={{ color: 'var(--color-text-3)' }}>{label}</p>
      <p className="mt-1 text-2xl font-semibold" style={{ color: 'var(--color-text)' }}>{value}</p>
      {detail && <p className="mt-0.5 text-xs" style={{ color: 'var(--color-text-3)' }}>{detail}</p>}
      {trend && (
        <p className="mt-1 text-sm font-medium" style={{ color: trend.value >= 0 ? 'var(--color-error)' : 'var(--color-success)' }}>
          {trend.value >= 0 ? '\u2191' : '\u2193'} {Math.abs(trend.value).toFixed(1)}% {trend.label}
        </p>
      )}
    </div>
  );
}
